<template>
  <div class="TopFilter top-filter-02 safe-area_width_2 pb--40">
    <slot name="filterType"></slot>
    <div class="type-filter f-layout">
      <span class="select-area-text">选择地区：</span>
      <div>
        <p class="mb--10">
          <a :href="getCompleteHref('2703')" :class="{ 'theme-color': areaId === '2703'|| areaId === 2703}">全国</a>
        </p>
        <div>
          <a
            v-for="item in allProvince"
            :key="item.value"
            :href="getCompleteHref(item.value)"
            :title="`${item.text}${keyword}招标信息-千里马招标网`"
            class="single-area-a hover-text_theme"
            :class="currentParentIdArr.includes(item.value) ? 'theme-color' : ''"
            >{{ item.text }}</a
          >
        </div>
        <ChilMenu  :current-parent-id-arr="currentParentIdArr" :keyword="keyword" :current-obj="currentObj"   :pageType="pageType"></ChilMenu>

      </div>
    </div>
  </div>
</template>

<script>
import {padStart}from "lodash";
import regionHotData from "@/utils/constants/qlm_hot_regionData"
import ChilMenu from "./ChilMenu.vue"
export default {
  name: "TopFilter",
  components: { ChilMenu },
  props: {},
  data() {
    return {
      type: "sheng",
      // 深度克隆地区数据
      cloneRegionData: [],
      pageType:'hot'
    }
  },
  computed: {
    publicResource() {
      return this.$store.getters["hot/otherObj"];
    },
    areaId() {
      return this.publicResource.areaId
    },
    wId() {
      return this.publicResource.wId
    },
   keyword () {
      return this.publicResource.keyword
    },

    currentAreaObj() {
      const areaId = padStart(this.areaId, 4, "0")
      const currentObj = this.getParentObj(this.cloneRegionData, areaId);
      return currentObj || {}
    },
    currentObj() {
      return this.currentAreaObj.find(item=>item.level===1)||{}
    },
    currentCityArr() {
      return this.currentAreaObj.length ? this.currentAreaObj[0].children : []
    },
    currentParentIdArr() {
      return this.currentAreaObj.length ? this.currentAreaObj.map((item) => item.value) : []
    }, 
    // 所有省数据
    allProvince() {
      return this.cloneRegionData.map((item) => {
        return {
          text: item.text,
          value: item.value,
        }
      })
    },
  },
  created() {
    this.cloneRegionData =   this.formatTree(regionHotData,1,0);
  },
  methods: {
    // 根据id获取当前树形结构
    getParentObj(tree, id) {
      const allparents = []
      if (tree.length === 0) {
        return
      }
      const findele = (data, id) => {
        if (!id) return
        data.forEach((item, index) => {
          if (item.value === id) {
            allparents.unshift(item)
            findele(tree, item.parent)
          } else if (item.children) {
            findele(item.children, id)
          }
        })
      }
      findele(tree, id)
      return  allparents
    },
    // 格式化数据
    formatTree(tree, level, value) {
      for (const item of tree) {
        item.level = level
        item.parent = level === 1 ? "" : value
        if (item.children && item.children.length > 0) {
          if (item.children[0].text === "全部") item.children.shift() // 删除全部选项
          this.formatTree(item.children, item.level + 1, item.value)
        }
      }
      return tree
    },
    // 获取完整url
    getCompleteHref(val) {
      const { typeId, wId } = this.publicResource
      const typeStr = typeId ? "_" + typeId : ""

      let href= ""
      switch (this.pageType) {
        case "hot":
          href = `/hot${wId}${val}/`
          break
        case "gjxx":
          href = `/gjxx/${wId}_${val}${typeStr}`
          break
      }
      return href
    },
  },
}
</script>


<style lang="scss">
@import "@/assets/variable.scss";
.TopFilter {
  &.top-filter-02 {
    border: 1px solid #e5e5e5;
    padding: 20px;
    font-size: 14px;
  }

  .select-area-text {
    width: 106px;
  }

  .a-link {
    display: inline-block;
  }

  .type-filter {
    .select-area-text {
      width: 100px;
    }

    .single-area-a{
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 5px;
      &.theme-color{
        color:$theme-color;
      }
    }
  }

 
}
</style>
